/** Build metadata injected by vite.config.ts `define`. Shown in the debug menu and sent as a header. */
export const BUILD: Readonly<BuildInfo> = __BUILD_INFO__;
export const CLIENT_BUILD_ID = `${BUILD.version}+${BUILD.commit}`;
